import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from '../api/axios';

type AuthContextType = {
  token: string | null;
  user: any;
  isAuthLoading: boolean;
  setUser: (user: any) => void;
};

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const params = new URLSearchParams(window.location.search);
      const tokenFromUrl = params.get('token');

      let activeToken = tokenFromUrl;

      if (tokenFromUrl) {
        localStorage.setItem('auth_token', tokenFromUrl);
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        activeToken = localStorage.getItem('auth_token');
      }

      if (!activeToken) {
        setIsAuthLoading(false);
        return;
      }

      setToken(activeToken);

      try {
        const res = await axios.get('me', {
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        setUser(res.data.data);
      } catch (err) {
        console.error('❌ gagal fetch user', err);
        setUser(null);
        setToken(null);
        localStorage.removeItem('auth_token');
      } finally {
        setIsAuthLoading(false);
      }
    };

    initAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, setUser, isAuthLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
